var deadzone = 25;

export default class GestureRecognizer {
	constructor(target) {
		this.events = {
			swipeup: [],
			swipedown: [],
			swipeleft: [],
			swiperight: []
		};

		this.touchStart = null;
		this.touchEnd = null;

		target.addEventListener('touchstart', event => {
			if (target === event.target)
				this.touchStart = { x: event.changedTouches[0].screenX, y: event.changedTouches[0].screenY };
		});

		target.addEventListener('touchend', event => {
			if (this.touchStart !== null) {
				this.touchEnd = { x: event.changedTouches[0].screenX, y: event.changedTouches[0].screenY };
				this.parseGesture();
			}
		});

	}

	parseGesture() {
		var vertChange = this.touchEnd.y - this.touchStart.y;
		var horizChange = this.touchEnd.x - this.touchStart.x;

		if (Math.abs(vertChange) > Math.abs(horizChange)) {
			if (vertChange > deadzone)
				this.fireEvents('swipedown');
			else if (vertChange < -deadzone)
				this.fireEvents('swipeup');
		}
		else {
			if (horizChange > deadzone)
				this.fireEvents('swiperight');
			else if (horizChange < -deadzone)
				this.fireEvents('swipeleft');
		}

		this.touchStart = null;
		this.touchEnd = null;
	}

	fireEvents(ev) {
		for(var e of this.events[ev])
			e();
	}

	on(ev, callback) {
		this.events[ev].push(callback);
	}

	off(ev, callback) {
		this.events[ev].splice(this.events[ev].indexOf(callback));
	}
}
